<template>
  <div class="ibox-content">
    <div class="row mt-4">
      <div class="col-md-12">
        <strong>
          {{infoTotalModels}}
        </strong>
      </div>
    </div>

    <!-- Table -->
    <div class="row flex-fill d-flex justify-content-start">
      <div class="col-md-12 mt-2">
        <table class="table table-borderless table-border table-align">
          <thead>
            <tr>
              <th>AIT</th>
              <th>Placa</th>
              <th>Renavam</th>
              <th>Status</th>
              <th>Valor</th>
              <th>Data/Hora da infração</th>
              <th>Atualizado em</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="history in ticketHistories" :key="history.id">
              <td>{{ history.ait }}</td>
              <td>{{ history.plate }}</td>
              <td>{{ history.renavam }}</td>
              <td>{{ translateStatus(history.status) }}</td>
              <td>{{ history.valueCents | price }}</td>
              <td>{{ history.occurredAt | datetime }}</td>
              <td>{{ history.updatedAt | datetime }}</td>
              <td>
                <button v-if="isSuperUser" class="btn btn-primary" @click="showDetails(history)">
                  Detalhes
                </button>
              </td>
            </tr>
          </tbody>

        <!--    <pre><code>{{ tickets[0] }}</code></pre>-->
        </table>
      </div>
    </div>

    <!-- Pagination -->
    <div class="row">
      <div class="col-md-12 my-1">
        <Pagination
          v-model="meta.currentPage"
          :total-count="meta.totalCount"
          :total-pages="meta.totalPages"
          @pagination="pagination"
        />
      </div>
    </div>

    <Modal v-model="showModal" v-if="currentTicketHistory">
      <pre><small><code>{{ currentTicketHistory }}</code></small></pre>
    </Modal>

  </div>
</template>
<script>

import ModelMapper from '@/mixins/ModelMapper'
import Modal from '../shares/specialTag/Modal.vue'
import GetUser from '@/mixins/GetUser'
import Pagination from '@/components/shares/specialTag/Pagination'
import { IssuingAuthority } from '@/models/IssuingAuthority'

export default {
  components: { Modal, Pagination },
  computed: {
    ticketHistories() {
      return this.getModels || []
    },
  },
  created() {
    this.addOrderBy('createdAt')

    this.asyncTemplateSelect()
  },
  data: () => ({
    currentTicketHistory: null,
    modelPathPrefix: 'maestro',
    nameModel: 'TicketHistories',
    showModal: false,
    ticketId: null,
  }),
  methods: {
    buildPath() {
      return `maestro/tickets/${this.ticket.id}/histories`
    },
    showDetails(ticketHistory) {
      this.currentTicketHistory = ticketHistory
      this.showModal = true
    },
    translateStatus(value) {
      return {
        expired: 'Vencido',
        opened: 'Em aberto',
        undefined: 'Indefinido',
        paid: 'Pago',
        canceled: 'Cancelado',
        prescribed: 'Prescrito',
        not_available: 'Saiu do site',
        autuacao: 'Autuação',
        em_recurso: 'Em recurso',
        encerrado: 'Encerrado',
        outros: 'Outros',
      }[value] || value
    },
    translateAuthority(value) {
      return IssuingAuthority.label(value)
    },
  },
  mixins: [ModelMapper, GetUser],
  name: 'TicketHistories',
  props: {
    ticket: {
      required: true,
      type: Object,
    }
  }
}

</script>

<style scoped>

</style>
